// USI Security site-wide constants
export const COMPANY = {
  name: "USI Security Ltd",
  short: "USI Security",
  tagline: "Protecting Critical UK Infrastructure",
  phone: "+44 (0) 1268 947 077",
  email: "info@usisecurityltd.co.uk",
  address: "UK Wide",
  logo: "https://customer-assets-eiarnc6j.emergentagent.net/job_usi-next-gen/artifacts/124zcav7_ultimate-solutions-in-security-squ-logo.png",
  offices: [
    {
      id: "head-office",
      name: "Head Office · Essex",
      address_lines: ["Alexander House, Christy Cl", "Basildon, SS15 6TL"],
      phone: "+44 (0) 1268 947 077",
      phone_href: "+441268947077",
    },
    {
      id: "cardiff-office",
      name: "Cardiff Office",
      address_lines: ["4th Floor, 14 Museum Place", "City Centre, Cardiff, CF10 3BH"],
      phone: "029 2271 4608",
      phone_href: "+442922714608",
    },
  ],
  website: "https://www.usisec.co.uk/",
  legal: "USI Security Ltd · Registered in England & Wales",
};

export const ACCREDITATIONS = [
  { name: "Achilles", logo: "https://www.usisec.co.uk/wp-content/uploads/2025/01/achilles-logo-square.png" },
  { name: "Achilles UVDB Silver Plus", logo: "https://www.usisec.co.uk/wp-content/uploads/2025/01/Achilles-UVDB-logo-square.png" },
  { name: "Alcumus Safe Contractor", logo: "https://www.usisec.co.uk/wp-content/uploads/2025/01/Alcumus-logo-square.png" },
  { name: "Constructionline Gold", logo: "https://www.usisec.co.uk/wp-content/uploads/2025/01/constructionline-gold-logo-square.png" },
  { name: "ICO Registered", logo: "https://www.usisec.co.uk/wp-content/uploads/2025/01/ico-logo-square.png" },
  { name: "SSIP", logo: "https://www.usisec.co.uk/wp-content/uploads/2025/01/SSIP-logo-square.png" },
];

export const SERVICES = [
  {
    id: "manned-guarding",
    name: "Manned Guarding",
    short: "Visible Deterrence",
    headline: "SIA-licensed officers who prevent incidents before they happen.",
    description:
      "Professional, uniformed and clearly identified — our officers protect substations, construction sites, industrial units and events with calm, intelligent presence.",
    bullets: [
      "SIA-licensed and DBS-checked",
      "Site-specific briefing & assignment instructions",
      "Patrol logging & live reporting",
      "Rapid mobilisation at short notice",
    ],
    icon: "ShieldCheck",
  },
  {
    id: "cctv",
    name: "CCTV & Visual Surveillance",
    short: "Eyes On Every Inch",
    headline: "Fixed CCTV, mobile towers and pods — designed around your site.",
    description:
      "AI-augmented monitoring layered over rugged hardware. From single-camera deployments to multi-tower coverage of major UK construction sites.",
    bullets: [
      "Rapid-deploy CCTV towers & pods",
      "Solar-hybrid and mains-powered options",
      "4K cameras with thermal and analytics",
    ],
    icon: "Cctv",
  },
  {
    id: "k9-patrols",
    name: "K9 Patrols",
    short: "Unmatched Deterrence",
    headline: "Certified handlers and detection dogs — the quietest, fastest response.",
    description:
      "Where pure technology records, K9 patrols prevent. Trained dogs and experienced handlers cover ground rapidly and stop incidents in seconds.",
    bullets: [
      "Static and mobile patrol options",
      "Trespass deterrence on high-risk sites",
      "Discreet, professional presentation",
    ],
    icon: "Dog",
  },
  {
    id: "security-systems",
    name: "Security Systems",
    short: "Integrated Tech Stack",
    headline: "Access control, alarms and 24/7 control room monitoring — unified.",
    description:
      "Our engineers integrate access control, intruder alarms and remote monitoring into a single operational picture, watched over by our UK-based control room.",
    bullets: [
      "Remote monitoring",
      "Access control & visitor systems",
      "24/7 verified alarm response",
    ],
    icon: "Network",
  },
];

export const INDUSTRIES = [
  { name: "Substations", icon: "Zap", desc: "Critical power infrastructure protected day & night." },
  { name: "Construction", icon: "HardHat", desc: "Plant, copper and material loss prevention." },
  { name: "Industrial Units", icon: "Factory", desc: "Manufacturing and warehousing security." },
  { name: "Transport & Logistics", icon: "Truck", desc: "Yards, depots and rolling stock." },
  { name: "Events", icon: "Users", desc: "Crowd-safe deployments across the UK." },
  { name: "Utilities", icon: "Activity", desc: "Water, gas and renewable energy sites." },
];

export const STATS = [
  { value: "24/7", label: "Control room cover" },
  { value: "<60s", label: "Avg. alert response" },
  { value: "100%", label: "SIA-licensed officers" },
  { value: "UK Wide", label: "Coverage footprint" },
];
